// Keep the object URL alive long enough for the browser to start reading the
// blob after the click. Revoking synchronously races the download and, on
// slower/loaded machines, causes an empty (0-byte) file to be written.
export const DOWNLOAD_BLOB_URL_REVOKE_DELAY_MS = 30000;

export function downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    document.body.appendChild(anchor);
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    document.body.removeChild(anchor);
    // Defer the revoke so the browser has time to read the blob (avoids 0-byte downloads).
    setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_BLOB_URL_REVOKE_DELAY_MS);
}
